import Common from '../common'
var Js = Common('banner')
export default {
	name: 'banner',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 100
				},
				{
					key: 'mainImg',
					label: '图片',
					customSlot: 'mainImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%'
				},
				{
					key: 'listorder',
					label: '排序',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					placeholder: '请输入排序数字',
					width: 100
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					width: 180
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_labelUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_labelUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['IN', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_labelAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								description: '',
								mainImg: [],
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 1;
							self.submitData.parentid = 1;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},

			],

			searchItem: {
				type: 1,
				parentid: 1
			},
			startSearchItem: {
				type: 1,
				parentid: 1
			},
			optionData: {
				labelOptions: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				shopOptions:[]
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initShopData();
		},
		
		async initShopData() {
		
			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			// postData.getBefore = {
			// 	user:{
			// 		tableName:'User',
			// 		middleKey:'user_no',
			// 		key:'user_no',
			// 		condition:'=',
			// 		searchItem:{
			// 			user_type:1,
			// 			behavior:0
			// 		}
			// 	}
			// }
			postData.searchItem = {
				user_type:1,
				behavior:0
			}
			var res = await self.$$api_userGet({
				data: postData
			});
		
			if(res.info.data.length>0){
				res.info.data.forEach((item,index)=>{
					self.optionData.shopOptions.push(item.info)
				})
			}
			console.log('shop',self.optionData.shopOptions)
		
		},

		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			const postData = {};

			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				shopName: {
					tableName: 'UserInfo',
					middleKey:'url',
					key:'user_no',
					condition:'=',
					info:['name']
				}
			}
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.mainData = res.info.data;
		}

	},


}



// WEBPACK FOOTER //
// ./src/views/content/banner.js